import { Container, Grid, Link, Paper, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { SystemContext } from "../../Theme";
import { GoogleLoginButton } from "../Google/GoogleLoginButton";

export const Home: React.FC = () => {
  const { systemName } = React.useContext(SystemContext);

  return (
    <Grid container justifyContent="center" alignItems="center" height="100vh">
      <Grid item xs>
        <Container maxWidth="xs" fixed>
          <Paper elevation={24}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              direction="column"
              rowSpacing={2}
              padding={2}
            >
              <Grid item>
                <Typography>👋 Welcome to {systemName}!</Typography>
              </Grid>
              <Grid item>
                <Typography>Your Personalized AI Chatbot Assistant!</Typography>
              </Grid>
              <Grid item>
                <Typography>
                  New to this system?{"  "}
                  <Link
                    component={RouterLink}
                    style={{ color: "purple", fontWeight: "bold" }}
                    to="https://drive.google.com/file/d/1hMvdefRu6klXP_noVHN2LtawRtHv6oJm/view"
                    target="_blank"
                  >
                    User Guide
                  </Link>{" "}
                  here
                </Typography>
              </Grid>
              <Grid item>
                <Typography sx={{ marginLeft: "10px" }}>
                  Login with{"  "}
                  <span style={{ color: "purple", fontWeight: "bold" }}>
                    Google Account
                  </span>
                </Typography>
              </Grid>
              <Grid
                item
                container
                justifyContent="center"
                alignItems="center"
                columnSpacing={1}
              >
                <Grid item marginBottom={2}>
                  <GoogleLoginButton mode="login" />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </Grid>
    </Grid>
  );
};
